module.exports = __webpack_public_path__ + "img/sercomm-view_power-on-camera.0ae323b8.gif";